// extracted by mini-css-extract-plugin
export var component = "ArticleBody-module--component--f0xhF";
export var eventStylePreamble = "ArticleBody-module--eventStylePreamble--vsndS";
export var preamble = "ArticleBody-module--preamble--+K5Nt";